var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneToMany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 112,
    viewBox: "0 0 180 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3847 17.5H23.077C21.8025 17.5 20.7693 18.5447 20.7693 19.8333V22.1667C20.7693 23.4553 21.8025 24.5 23.077 24.5H25.3847C26.6592 24.5 27.6924 23.4553 27.6924 22.1667V19.8333C27.6924 18.5447 26.6592 17.5 25.3847 17.5Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6154 17.5H34.6154C33.3409 17.5 32.3077 18.5447 32.3077 19.8333V22.1667C32.3077 23.4553 33.3409 24.5 34.6154 24.5H64.6154C65.8899 24.5 66.9231 23.4553 66.9231 22.1667V19.8333C66.9231 18.5447 65.8899 17.5 64.6154 17.5Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M158.077 31.5H21.9231C21.2859 31.5 20.7693 32.0223 20.7693 32.6667C20.7693 33.311 21.2859 33.8333 21.9231 33.8333H158.077C158.714 33.8333 159.231 33.311 159.231 32.6667C159.231 32.0223 158.714 31.5 158.077 31.5Z",
    fill: "#D1D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3847 47.833H23.077C21.8025 47.833 20.7693 48.8777 20.7693 50.1663V52.4997C20.7693 53.7883 21.8025 54.833 23.077 54.833H25.3847C26.6592 54.833 27.6924 53.7883 27.6924 52.4997V50.1663C27.6924 48.8777 26.6592 47.833 25.3847 47.833Z",
    fill: "#D1D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6924 47.833H34.6154C33.3409 47.833 32.3077 48.8777 32.3077 50.1663V52.4997C32.3077 53.7883 33.3409 54.833 34.6154 54.833H87.6924C88.9669 54.833 90 53.7883 90 52.4997V50.1663C90 48.8777 88.9669 47.833 87.6924 47.833Z",
    fill: "#D1D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M158.077 61.833H21.9231C21.2859 61.833 20.7693 62.3553 20.7693 62.9997C20.7693 63.644 21.2859 64.1663 21.9231 64.1663H158.077C158.714 64.1663 159.231 63.644 159.231 62.9997C159.231 62.3553 158.714 61.833 158.077 61.833Z",
    fill: "#D1D5DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3847 78.167H23.077C21.8025 78.167 20.7693 79.2117 20.7693 80.5003V82.8337C20.7693 84.1223 21.8025 85.167 23.077 85.167H25.3847C26.6592 85.167 27.6924 84.1223 27.6924 82.8337V80.5003C27.6924 79.2117 26.6592 78.167 25.3847 78.167Z",
    fill: "#D1D5DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1539 78.167H34.6154C33.3409 78.167 32.3077 79.2117 32.3077 80.5003V82.8337C32.3077 84.1223 33.3409 85.167 34.6154 85.167H76.1539C77.4284 85.167 78.4616 84.1223 78.4616 82.8337V80.5003C78.4616 79.2117 77.4284 78.167 76.1539 78.167Z",
    fill: "#D1D5DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M158.077 92.167H21.9231C21.2859 92.167 20.7693 92.6893 20.7693 93.3337C20.7693 93.978 21.2859 94.5003 21.9231 94.5003H158.077C158.714 94.5003 159.231 93.978 159.231 93.3337C159.231 92.6893 158.714 92.167 158.077 92.167Z",
    fill: "#D1D5DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.946 17.1035L150 18.0605L153.06 21.1868L150 24.313L150.946 25.2702L154.985 21.1868L150.946 17.1035Z",
    fill: "#D1D5DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.946 47.833L150 48.79L153.06 51.9163L150 55.0427L150.946 55.9997L154.985 51.9163L150.946 47.833Z",
    fill: "#D1D5DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.946 78.167L150 79.124L153.06 82.2503L150 85.3766L150.946 86.3337L154.985 82.2503L150.946 78.167Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToMany);
export default __webpack_public_path__ + "static/media/oneToMany.ce088e3f6624c71cb0f675434a683064.svg";
export { ForwardRef as ReactComponent };